import axios from "axios";
import { retrieveData } from "../LocalConnection/LocalConnection.js";

let APL_LINK_AI = "https://backendpython.wowreviews.co/";

let Website_URL = "https://www.wowreviews.co/";
const GOOGLE_CLIENT_ID =
  "1025063694947-vig9gf2j8f95srb0o6neicce6gibh9mv.apps.googleusercontent.com";
const GOOGLE_CLIENT_SECRET = "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";
const REACT_APP_FACEBOOK_APP_ID = "1132956361970766";
const GOOGLE_REDIRECTION_URL = "https://app.wowreviews.co";

const local_server_link_react_aireport = APL_LINK_AI + "api/admin_link/";

/* Old PHP APIS  */
// let APL_LINK = "https://www.superpanel.wowreviews.co/";
// const local_server_link_react = APL_LINK + "ReactMaster/";
const insert_update_business_data_onboarding =
  local_server_link_react_aireport + "insert_update_business_data_onboarding";
const save_custom_qr_manage = local_server_link_react_aireport + "save_custom_qr_manage"; //work in image upload need already make in python
const update_profile = local_server_link_react_aireport + "update_profile"; //work in image upload need already make in python
const business_business_data =
  local_server_link_react_aireport + "business_business_data"; //work in image upload need already make in python
/* Old PHP APIS  */

/* New Python APIS  */
const facebooklogin = local_server_link_react_aireport + "facebookLogin";
const replay_on_review = local_server_link_react_aireport + "replay_on_review";
const pre_pay_payment = local_server_link_react_aireport + "pre_pay_payment";
const get_all_data_onboarding =
  local_server_link_react_aireport + "get_all_data_onboarding";
const searchTripadvisorLocation =
  local_server_link_react_aireport + "searchTripadvisorLocation";
const getLocationID = local_server_link_react_aireport + "getLocationID";
const apple_login = local_server_link_react_aireport + "apple_login";
const refresh_platform_token =
  local_server_link_react_aireport + "refresh_platform_token";
const sync_all_reviews = local_server_link_react_aireport + "sync_all_reviews";
const custom_package_All =
  local_server_link_react_aireport + "custom_package_All";
const cancel_subs = local_server_link_react_aireport + "cancel_subs";
const deactivatePlatformFlag =
  local_server_link_react_aireport + "deactivatePlatformFlag";
const delete_new_users = local_server_link_react_aireport + "delete_new_users";
const sms_dashboard = local_server_link_react_aireport + "sms_dashboard";
const save_customer_bulk =
  local_server_link_react_aireport + "save_customer_bulk";
const save_new_user = local_server_link_react_aireport + "add_new_users";
const review_summary = local_server_link_react_aireport + "review_summary";
const custom_qr_manage = local_server_link_react_aireport + "custom_qr_manage";
const edit_profile = local_server_link_react_aireport + "edit_profile";
const new_dashboard = local_server_link_react_aireport + "new_dashboard";
const custom_bad_reviews_all =
  local_server_link_react_aireport + "custom_bad_reviews_all";
const custom_favorite_reviews =
  local_server_link_react_aireport + "custom_favorite_reviews";
const custom_open_close_reviews =
  local_server_link_react_aireport + "custom_open_close_reviews";
const custom_update_archives_reviews =
  local_server_link_react_aireport + "custom_update_archives_reviews";
const ticket_save = local_server_link_react_aireport + "ticket_save";
const open_ticket = local_server_link_react_aireport + "open_ticket";
const resolve_ticket = local_server_link_react_aireport + "resolve_ticket";
const ticket_view_detail =
  local_server_link_react_aireport + "ticket_view_detail";
const reply_ticket = local_server_link_react_aireport + "reply_ticket";
const firebase_notification =
  local_server_link_react_aireport + "firebase_notification";
const get_bus_counter_by_id =
  local_server_link_react_aireport + "get_bus_counter_by_id";
const get_all_reviews_link =
  local_server_link_react_aireport + "get_all_reviews_link";
const save_reviews_link_manually =
  local_server_link_react_aireport + "save_reviews_link_manually";
const login_user_email = local_server_link_react_aireport + "login_user_email";
const refresh_access_token =
  local_server_link_react_aireport + "refresh_access_token";
const logout_user = local_server_link_react_aireport + "logout_user";
/* New Python APIS  */

const get_ai_business_report =
  local_server_link_react_aireport + "get_ai_business_report";
const delete_ai_report = local_server_link_react_aireport + "delete_ai_report";
const get_ai_report_detail =
  local_server_link_react_aireport + "get_ai_report_detail";
const get_ai_report_history =
  local_server_link_react_aireport + "get_ai_report_history";

const get_gmb_locations =
  local_server_link_react_aireport + "get_gmb_locations";
const get_gmb_location_details =
  local_server_link_react_aireport + "get_gmb_location_details";
const get_gmb_reviews = local_server_link_react_aireport + "get_gmb_reviews";
const reply_gmb_review = local_server_link_react_aireport + "reply_gmb_review";
const delete_gmb_review_reply =
  local_server_link_react_aireport + "delete_gmb_review_reply";
const get_gmb_insights = local_server_link_react_aireport + "get_gmb_insights";
const get_gmb_posts = local_server_link_react_aireport + "get_gmb_posts";
const create_gmb_post = local_server_link_react_aireport + "create_gmb_post";
const update_gmb_post = local_server_link_react_aireport + "update_gmb_post";
const delete_gmb_post = local_server_link_react_aireport + "delete_gmb_post";
const get_gmb_media = local_server_link_react_aireport + "get_gmb_media";
const upload_gmb_media = local_server_link_react_aireport + "upload_gmb_media";
const search_gmb_categories =
  local_server_link_react_aireport + "search_gmb_categories";
const update_gmb_location_profile =
  local_server_link_react_aireport + "update_gmb_location_profile";
const get_gmb_attributes =
  local_server_link_react_aireport + "get_gmb_attributes";
const update_gmb_attributes =
  local_server_link_react_aireport + "update_gmb_attributes";
const get_ai_smart_reply =
  local_server_link_react_aireport + "get_ai_smart_reply";
const get_gmb_search_keywords =
  local_server_link_react_aireport + "get_gmb_search_keywords";
const delete_gmb_media = local_server_link_react_aireport + "delete_gmb_media";
const get_gmb_competitors =
  local_server_link_react_aireport + "get_gmb_competitors";
// ==================== FACEBOOK ====================
const connect_facebook_account =
  local_server_link_react_aireport + "connect_facebook_account";
const save_facebook_page =
  local_server_link_react_aireport + "save_facebook_page";
const disconnect_facebook_page =
  local_server_link_react_aireport + "disconnect_facebook_page";
const get_facebook_pages =
  local_server_link_react_aireport + "get_facebook_pages";
const get_facebook_page_details =
  local_server_link_react_aireport + "get_facebook_page_details";
const update_facebook_page =
  local_server_link_react_aireport + "update_facebook_page";
const get_facebook_posts =
  local_server_link_react_aireport + "get_facebook_posts";
const create_facebook_post =
  local_server_link_react_aireport + "create_facebook_post";
const update_facebook_post =
  local_server_link_react_aireport + "update_facebook_post";
const delete_facebook_post =
  local_server_link_react_aireport + "delete_facebook_post";
const get_facebook_comments =
  local_server_link_react_aireport + "get_facebook_comments";
const reply_facebook_comment =
  local_server_link_react_aireport + "reply_facebook_comment";
const delete_facebook_comment =
  local_server_link_react_aireport + "delete_facebook_comment";
const hide_facebook_comment =
  local_server_link_react_aireport + "hide_facebook_comment";
const get_facebook_reviews =
  local_server_link_react_aireport + "get_facebook_reviews";
const reply_facebook_review =
  local_server_link_react_aireport + "reply_facebook_review";
const get_facebook_insights =
  local_server_link_react_aireport + "get_facebook_insights";
const get_facebook_post_insights =
  local_server_link_react_aireport + "get_facebook_post_insights";
const get_facebook_media =
  local_server_link_react_aireport + "get_facebook_media";
const upload_facebook_media =
  local_server_link_react_aireport + "upload_facebook_media";
const delete_facebook_media =
  local_server_link_react_aireport + "delete_facebook_media";

const connect_instagram_account =
  local_server_link_react_aireport + "connect_instagram_account";
const save_instagram_account =
  local_server_link_react_aireport + "save_instagram_account";
const disconnect_instagram_account =
  local_server_link_react_aireport + "disconnect_instagram_account";
const get_instagram_account =
  local_server_link_react_aireport + "get_instagram_account";
const get_instagram_media =
  local_server_link_react_aireport + "get_instagram_media";
const get_instagram_media_details =
  local_server_link_react_aireport + "get_instagram_media_details";
const publish_instagram_media =
  local_server_link_react_aireport + "publish_instagram_media";
const get_instagram_publish_limit =
  local_server_link_react_aireport + "get_instagram_publish_limit";
const update_instagram_media =
  local_server_link_react_aireport + "update_instagram_media";
const delete_instagram_media =
  local_server_link_react_aireport + "delete_instagram_media";
const get_instagram_comments =
  local_server_link_react_aireport + "get_instagram_comments";
const reply_instagram_comment =
  local_server_link_react_aireport + "reply_instagram_comment";
const hide_instagram_comment =
  local_server_link_react_aireport + "hide_instagram_comment";
const delete_instagram_comment =
  local_server_link_react_aireport + "delete_instagram_comment";
const get_instagram_insights =
  local_server_link_react_aireport + "get_instagram_insights";
const get_instagram_media_insights =
  local_server_link_react_aireport + "get_instagram_media_insights";
const get_instagram_tagged_media =
  local_server_link_react_aireport + "get_instagram_tagged_media";
const search_instagram_hashtag =
  local_server_link_react_aireport + "search_instagram_hashtag";
const upload_public_media =
  local_server_link_react_aireport + "upload_public_media";

// ============================ LINKEDIN ============================
const get_linkedin_auth_url =
  local_server_link_react_aireport + "get_linkedin_auth_url";
const linkedin_oauth_callback =
  local_server_link_react_aireport + "linkedin_oauth_callback";
const save_linkedin_page =
  local_server_link_react_aireport + "save_linkedin_page";
const disconnect_linkedin_page =
  local_server_link_react_aireport + "disconnect_linkedin_page";
const get_linkedin_page_details =
  local_server_link_react_aireport + "get_linkedin_page_details";
const upload_linkedin_media =
  local_server_link_react_aireport + "upload_linkedin_media";
const get_linkedin_posts =
  local_server_link_react_aireport + "get_linkedin_posts";
const create_linkedin_post =
  local_server_link_react_aireport + "create_linkedin_post";
const delete_linkedin_post =
  local_server_link_react_aireport + "delete_linkedin_post";
const get_linkedin_comments =
  local_server_link_react_aireport + "get_linkedin_comments";
const reply_linkedin_comment =
  local_server_link_react_aireport + "reply_linkedin_comment";
const delete_linkedin_comment =
  local_server_link_react_aireport + "delete_linkedin_comment";
const react_linkedin_post =
  local_server_link_react_aireport + "react_linkedin_post";
const get_linkedin_insights =
  local_server_link_react_aireport + "get_linkedin_insights";
const get_linkedin_follower_demographics =
  local_server_link_react_aireport + "get_linkedin_follower_demographics";

// ============================ TWITTER / X ============================
const get_twitter_auth_url =
  local_server_link_react_aireport + "get_twitter_auth_url";
const twitter_oauth_callback =
  local_server_link_react_aireport + "twitter_oauth_callback";
const save_twitter_account =
  local_server_link_react_aireport + "save_twitter_account";
const disconnect_twitter_account =
  local_server_link_react_aireport + "disconnect_twitter_account";
const get_twitter_account =
  local_server_link_react_aireport + "get_twitter_account";
const upload_twitter_media =
  local_server_link_react_aireport + "upload_twitter_media";
const get_twitter_tweets =
  local_server_link_react_aireport + "get_twitter_tweets";
const create_twitter_tweet =
  local_server_link_react_aireport + "create_twitter_tweet";
const delete_twitter_tweet =
  local_server_link_react_aireport + "delete_twitter_tweet";
const get_twitter_replies =
  local_server_link_react_aireport + "get_twitter_replies";
const react_twitter_tweet =
  local_server_link_react_aireport + "react_twitter_tweet";
const get_twitter_insights =
  local_server_link_react_aireport + "get_twitter_insights";
const get_twitter_mentions =
  local_server_link_react_aireport + "get_twitter_mentions";
const search_twitter_tweets =
  local_server_link_react_aireport + "search_twitter_tweets";

// ============================ TIKTOK ============================
const get_tiktok_auth_url =
  local_server_link_react_aireport + "get_tiktok_auth_url";
const tiktok_oauth_callback =
  local_server_link_react_aireport + "tiktok_oauth_callback";
const save_tiktok_account =
  local_server_link_react_aireport + "save_tiktok_account";
const disconnect_tiktok_account =
  local_server_link_react_aireport + "disconnect_tiktok_account";
const get_tiktok_account =
  local_server_link_react_aireport + "get_tiktok_account";
const get_tiktok_creator_info =
  local_server_link_react_aireport + "get_tiktok_creator_info";
const get_tiktok_videos =
  local_server_link_react_aireport + "get_tiktok_videos";
const get_tiktok_video_details =
  local_server_link_react_aireport + "get_tiktok_video_details";
const publish_tiktok_video =
  local_server_link_react_aireport + "publish_tiktok_video";
const publish_tiktok_photo =
  local_server_link_react_aireport + "publish_tiktok_photo";
const get_tiktok_publish_status =
  local_server_link_react_aireport + "get_tiktok_publish_status";
const get_tiktok_comments =
  local_server_link_react_aireport + "get_tiktok_comments";
const reply_tiktok_comment =
  local_server_link_react_aireport + "reply_tiktok_comment";
const hide_tiktok_comment =
  local_server_link_react_aireport + "hide_tiktok_comment";
const delete_tiktok_comment =
  local_server_link_react_aireport + "delete_tiktok_comment";
const get_tiktok_insights =
  local_server_link_react_aireport + "get_tiktok_insights";

// ============================ THREADS ============================
const get_threads_auth_url =
  local_server_link_react_aireport + "get_threads_auth_url";
const threads_oauth_callback =
  local_server_link_react_aireport + "threads_oauth_callback";
const save_threads_account =
  local_server_link_react_aireport + "save_threads_account";
const disconnect_threads_account =
  local_server_link_react_aireport + "disconnect_threads_account";
const get_threads_account =
  local_server_link_react_aireport + "get_threads_account";
const get_threads_quota =
  local_server_link_react_aireport + "get_threads_quota";
const get_threads_posts =
  local_server_link_react_aireport + "get_threads_posts";
const get_threads_post_details =
  local_server_link_react_aireport + "get_threads_post_details";
const publish_threads_post =
  local_server_link_react_aireport + "publish_threads_post";
const publish_threads_chain =
  local_server_link_react_aireport + "publish_threads_chain";
const delete_threads_post =
  local_server_link_react_aireport + "delete_threads_post";
const get_threads_replies =
  local_server_link_react_aireport + "get_threads_replies";
const reply_threads_post =
  local_server_link_react_aireport + "reply_threads_post";
const hide_threads_reply =
  local_server_link_react_aireport + "hide_threads_reply";
const get_threads_post_insights =
  local_server_link_react_aireport + "get_threads_post_insights";
const get_threads_insights =
  local_server_link_react_aireport + "get_threads_insights";
const get_threads_demographics =
  local_server_link_react_aireport + "get_threads_demographics";
const search_threads_posts =
  local_server_link_react_aireport + "search_threads_posts";

// ============================ PINTEREST ============================
const get_pinterest_auth_url =
  local_server_link_react_aireport + "get_pinterest_auth_url";
const pinterest_oauth_callback =
  local_server_link_react_aireport + "pinterest_oauth_callback";
const save_pinterest_account =
  local_server_link_react_aireport + "save_pinterest_account";
const disconnect_pinterest_account =
  local_server_link_react_aireport + "disconnect_pinterest_account";
const get_pinterest_account =
  local_server_link_react_aireport + "get_pinterest_account";
const get_pinterest_boards =
  local_server_link_react_aireport + "get_pinterest_boards";
const create_pinterest_board =
  local_server_link_react_aireport + "create_pinterest_board";
const update_pinterest_board =
  local_server_link_react_aireport + "update_pinterest_board";
const delete_pinterest_board =
  local_server_link_react_aireport + "delete_pinterest_board";
const get_pinterest_board_sections =
  local_server_link_react_aireport + "get_pinterest_board_sections";
const upload_pinterest_video =
  local_server_link_react_aireport + "upload_pinterest_video";
const get_pinterest_pins =
  local_server_link_react_aireport + "get_pinterest_pins";
const get_pinterest_pin_details =
  local_server_link_react_aireport + "get_pinterest_pin_details";
const create_pinterest_pin =
  local_server_link_react_aireport + "create_pinterest_pin";
const update_pinterest_pin =
  local_server_link_react_aireport + "update_pinterest_pin";
const delete_pinterest_pin =
  local_server_link_react_aireport + "delete_pinterest_pin";
const save_pinterest_pin =
  local_server_link_react_aireport + "save_pinterest_pin";
const get_pinterest_insights =
  local_server_link_react_aireport + "get_pinterest_insights";
const get_pinterest_pin_insights =
  local_server_link_react_aireport + "get_pinterest_pin_insights";
const get_pinterest_top_pins =
  local_server_link_react_aireport + "get_pinterest_top_pins";
const get_pinterest_board_insights =
  local_server_link_react_aireport + "get_pinterest_board_insights";

// ============================ SOCIAL DASHBOARD ============================
const get_social_dashboard =
  local_server_link_react_aireport + "get_social_dashboard";
const get_social_connections =
  local_server_link_react_aireport + "get_social_connections";

// ==================== THE DASHBOARD ====================
const get_intelligence_dashboard =
  local_server_link_react_aireport + "get_intelligence_dashboard";

// ==================== COMPETITOR WORKSPACE ====================
const search_competitors =
  local_server_link_react_aireport + "search_competitors";
const update_competitor =
  local_server_link_react_aireport + "update_competitor";
const remove_competitor_search =
  local_server_link_react_aireport + "remove_competitor_search";
const add_selected_competitors =
  local_server_link_react_aireport + "add_selected_competitors";

// ==================== REVIEW CONTENT ====================
const update_content_card =
  local_server_link_react_aireport + "update_content_card";
const regenerate_content_cards =
  local_server_link_react_aireport + "regenerate_content_cards";

// ==================== RECOMMENDATIONS ====================
const update_recommendation =
  local_server_link_react_aireport + "update_recommendation";
const regenerate_recommendations =
  local_server_link_react_aireport + "regenerate_recommendations";

// ==================== EVIDENCE & SYNC ====================
const get_theme_evidence =
  local_server_link_react_aireport + "get_theme_evidence";
const trigger_sync = local_server_link_react_aireport + "trigger_sync";
const get_sync_status = local_server_link_react_aireport + "get_sync_status";

//==================Menu
const get_menu_data = local_server_link_react_aireport + "get_menu_data";
const save_category = local_server_link_react_aireport + "save_category";
const update_category_status =
  local_server_link_react_aireport + "update_category_status";
const delete_category = local_server_link_react_aireport + "delete_category";
const save_menu_item = local_server_link_react_aireport + "save_menu_item";
const update_item_status =
  local_server_link_react_aireport + "update_item_status";
const delete_menu_items =
  local_server_link_react_aireport + "delete_menu_items";
const move_menu_items = local_server_link_react_aireport + "move_menu_items";
const preview_menu_upload =
  local_server_link_react_aireport + "preview_menu_upload";
const bulk_upload_menu = local_server_link_react_aireport + "bulk_upload_menu";
//==================Menu

/* New Python APIS  */
const server_post_data = async (url_for, Data) => {
  try {
    if (Data === null) {
      Data = new FormData();
    }

    let customer_id = retrieveData("customer_id");
    let final_bus_id = retrieveData("final_bus_id");
    let counter_bus_id = retrieveData("counter_bus_id");
    let access_token = retrieveData("access_token");
    Data.append("key_secret", "wowreviews_key@2022");
    Data.append("admin_web_app", "manager");
    Data.append("final_buu_id", customer_id);
    Data.append("final_bus_id", final_bus_id);
    Data.append("counter_bus_id", counter_bus_id);
    const response = await axios.post(url_for, Data, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...(access_token &&
          access_token !== "1" &&
          url_for !== login_user_email && {
            Authorization: `Bearer ${access_token}`,
          }),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export {
  REACT_APP_FACEBOOK_APP_ID,
  custom_bad_reviews_all,
  custom_favorite_reviews,
  custom_open_close_reviews,
  custom_package_All,
  custom_qr_manage,
  custom_update_archives_reviews,
  delete_new_users,
  edit_profile,
  firebase_notification,
  getLocationID,
  // all urls
  new_dashboard,
  open_ticket,
  reply_ticket,
  resolve_ticket,
  save_custom_qr_manage,
  save_customer_bulk,
  save_new_user,
  server_post_data,
  sms_dashboard,
  ticket_save,
  ticket_view_detail,
  update_profile,
  Website_URL,
  GOOGLE_CLIENT_ID,
  GOOGLE_CLIENT_SECRET,
  GOOGLE_REDIRECTION_URL,
  get_bus_counter_by_id,
  get_all_reviews_link,
  save_reviews_link_manually,
  replay_on_review,
  business_business_data,
  facebooklogin,
  get_ai_smart_reply,
  get_all_data_onboarding,
  insert_update_business_data_onboarding,
  pre_pay_payment,
  login_user_email,
  apple_login,
  review_summary,
  cancel_subs,
  deactivatePlatformFlag,
  searchTripadvisorLocation,
  get_ai_business_report,
  get_gmb_locations,
  get_gmb_reviews,
  reply_gmb_review,
  get_gmb_insights,
  get_gmb_posts,
  create_gmb_post,
  delete_gmb_post,
  get_gmb_media,
  get_gmb_location_details,
  update_gmb_post,
  delete_gmb_review_reply,
  upload_gmb_media,
  search_gmb_categories,
  update_gmb_location_profile,
  get_gmb_attributes,
  update_gmb_attributes,
  get_gmb_search_keywords,
  delete_gmb_media,
  get_gmb_competitors,
  create_facebook_post,
  get_facebook_page_details,
  connect_facebook_account,
  get_facebook_posts,
  delete_facebook_post,
  get_facebook_comments,
  reply_facebook_comment,
  delete_facebook_comment,
  hide_facebook_comment,
  get_facebook_reviews,
  reply_facebook_review,
  get_facebook_insights,
  get_facebook_media,
  delete_facebook_media,
  save_facebook_page,
  upload_facebook_media,
  update_facebook_post,
  connect_instagram_account,
  delete_instagram_comment,
  delete_instagram_media,
  get_instagram_account,
  get_instagram_comments,
  get_instagram_insights,
  get_instagram_media,
  get_instagram_media_insights,
  get_instagram_publish_limit,
  get_instagram_tagged_media,
  hide_instagram_comment,
  publish_instagram_media,
  reply_instagram_comment,
  save_instagram_account,
  search_instagram_hashtag,
  update_instagram_media,
  upload_public_media,
  create_linkedin_post,
  delete_linkedin_comment,
  delete_linkedin_post,
  get_linkedin_auth_url,
  get_linkedin_comments,
  get_linkedin_follower_demographics,
  get_linkedin_insights,
  get_linkedin_page_details,
  get_linkedin_posts,
  linkedin_oauth_callback,
  react_linkedin_post,
  reply_linkedin_comment,
  save_linkedin_page,
  upload_linkedin_media,
  create_twitter_tweet,
  delete_twitter_tweet,
  get_twitter_account,
  get_twitter_auth_url,
  get_twitter_insights,
  get_twitter_mentions,
  get_twitter_replies,
  get_twitter_tweets,
  react_twitter_tweet,
  save_twitter_account,
  search_twitter_tweets,
  twitter_oauth_callback,
  upload_twitter_media,
  delete_tiktok_comment,
  get_tiktok_account,
  get_tiktok_auth_url,
  get_tiktok_comments,
  get_tiktok_creator_info,
  get_tiktok_insights,
  get_tiktok_publish_status,
  get_tiktok_videos,
  hide_tiktok_comment,
  publish_tiktok_photo,
  publish_tiktok_video,
  reply_tiktok_comment,
  save_tiktok_account,
  tiktok_oauth_callback,
  delete_threads_post,
  get_threads_account,
  get_threads_auth_url,
  get_threads_demographics,
  get_threads_insights,
  get_threads_posts,
  get_threads_quota,
  get_threads_replies,
  hide_threads_reply,
  publish_threads_chain,
  publish_threads_post,
  reply_threads_post,
  save_threads_account,
  search_threads_posts,
  threads_oauth_callback,
  create_pinterest_board,
  create_pinterest_pin,
  delete_pinterest_board,
  delete_pinterest_pin,
  get_pinterest_account,
  get_pinterest_auth_url,
  get_pinterest_board_sections,
  get_pinterest_boards,
  get_pinterest_insights,
  get_pinterest_pin_insights,
  get_pinterest_pins,
  get_pinterest_top_pins,
  pinterest_oauth_callback,
  save_pinterest_account,
  update_pinterest_pin,
  upload_pinterest_video,
  get_social_dashboard,
  get_social_connections,
  get_intelligence_dashboard,
  get_sync_status,
  get_theme_evidence,
  regenerate_content_cards,
  regenerate_recommendations,
  remove_competitor_search,
  add_selected_competitors,
  search_competitors,
  trigger_sync,
  update_competitor,
  update_content_card,
  update_recommendation,
  delete_ai_report,
  get_ai_report_detail,
  get_ai_report_history,
  logout_user,
  bulk_upload_menu,
  delete_category,
  delete_menu_items,
  get_menu_data,
  move_menu_items,
  preview_menu_upload,
  save_category,
  save_menu_item,
  update_category_status,
  update_item_status,
  refresh_platform_token,
  sync_all_reviews,
};
